import { Box, Container, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { LinkButton } from 'components/atoms';
import { useMediaUp } from 'hooks';
import React, { FC } from 'react';
import { MultiDotsIcon, MultiLinesIcon, PlusIcon, RedCirclePointedIcon } from 'svgs';

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    backgroundColor: theme.palette.primary.dark,
    width: '100%',
    margin: theme.spacing(10, 0),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(15, 0),
    },
  },
  textGrid: {
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'center',
    },
  },
  whiteText: {
    color: theme.palette.common.white,
  },
  title: {
    position: 'relative',
    zIndex: 2,
    lineHeight: 1.5,
  },
  multiDotsIcon: {
    position: 'absolute',
    zIndex: 1,
    opacity: 0.5,
    top: theme.spacing(-12),
    left: theme.spacing(-7),
    transform: 'scale(0.75)',
    [theme.breakpoints.up('md')]: {
      transform: 'scale(1)',
    },
  },
  linkButton: {
    background: theme.palette.primary.light,
    '&:hover': {
      background: theme.palette.primary.light,
    },
  },
  text: {
    margin: theme.spacing(3, 0, 6),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(6, 0),
    },
  },
  multiLinesIcon: {
    maxWidth: '100%',
    height: 27,
    width: 140,
  },
  plusIcon1: {
    position: 'absolute',
    left: 40,
    bottom: 40,
  },
  plusIcon2: {
    position: 'absolute',
    right: 200,
    top: 80,
  },
  redCircle: {
    position: 'absolute',
    right: 0,
    bottom: 40,
  },
  containerWrapper: {
    position: 'relative',
    padding: theme.spacing(15, 0, 10),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(30, 0),
    },
  },
  list: {
    color: theme.palette.common.white,
    marginTop: theme.spacing(3),
    '& li': {
      fontWeight: 700,
      marginBottom: theme.spacing(2),
    },
  },
}));

const ContextualAdvertising: FC = () => {
  const classes = useStyles();
  const isMediumUp = useMediaUp('md');
  return (
    <Box className={classes.wrapper}>
      <Container fixed>
        <Box className={classes.containerWrapper}>
          {isMediumUp && (
            <>
              <PlusIcon className={classes.plusIcon1} />
              <PlusIcon className={classes.plusIcon2} />
              <RedCirclePointedIcon className={classes.redCircle} />
            </>
          )}
          <Grid container alignItems="center">
            <Grid item md={5} xs={12} className={classes.textGrid}>
              <Box position="relative">
                <MultiDotsIcon className={classes.multiDotsIcon} />
                <Typography className={clsx(classes.whiteText, classes.title)} variant="h1" component="h3">
                  Contextual <br /> advertising
                </Typography>
              </Box>
            </Grid>
            <Grid item md={6} xs={12}>
              {isMediumUp && <MultiLinesIcon className={classes.multiLinesIcon} viewBox="0 0 59 11" />}
              <Box className={classes.text}>
                <Typography className={classes.whiteText}>
                  PPC or Pay Per Click (PPC) advertising usually refers to "paid results" at the top or side of search results
                  (SERPs). You only pay when your ad is clicked. You can customize your PPC ads to appear when you enter specific
                  queries by creating an ad that targets a particular audience. At US Software Solutions, we use the following PPC
                  channels:
                </Typography>
                <Typography className={classes.list} component="ul">
                  <Typography component="li">Google Ads</Typography>
                  <Typography component="li">Facebook & Instagram Ads</Typography>
                  <Typography component="li">LinkedIn Ads.</Typography>
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default ContextualAdvertising;
